App.filter('dateFormatterLongNameMonth', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);

            var nameOfDay = nameMonth(time.getMonth());
            var all = nameOfDay;
        }
        return all;

        function nameMonth(numberOfMonth) {
        	var array = new Array(12);
        	array[0] = 'Styczeń';
			array[1] = 'Luty';
			array[2] = 'Marzec';
			array[3] = 'Kwiecień';
			array[4] = 'Maj';
			array[5] = 'Czerwiec';
			array[6] = 'Lipiec';
			array[7] = 'Sierpień';
			array[8] = 'Wrzesień';
			array[9] = 'Październik';
			array[10] = 'Listopad';
			array[11] = 'Grudzień';

			return array[numberOfMonth];
        }
    };
})